<template>
  <div class="block">
    <div class="block__item block__intro">
      <div class="block__intro-item">
        <h1>Настройте этапы</h1>
      </div>
      <div class="block__intro-item">
        <div class="text-md">
          Для&nbsp;сортировки результатов и&nbsp;определения победителей этапов
        </div>
      </div>
    </div>
    <div class="block__item">
      <form
        class="form"
        @submit.prevent="submit"
        novalidate
      >
        <div class="form__item">
          <div class="loader m-0" v-show="!ready"></div>
          <div v-show="ready">
            <div class="champ-stages">
              <div class="champ-stages__date">
                <b class="text-with-icon text-with-icon_wrap v-align-top">
                  <icon class="icon icon_fix color-muted" icon-name="calendar" w="18" h="18"></icon>
                  <span class="text-sm">{{ $moment(champ.StartDate).format('DD MMMM YYYY') }}</span>
                </b>
              </div>
              <div
                class="champ-stages__item"
                v-for="(item, i) in stages"
                :key="item.Id"
              >
                <button
                  class="link text-with-icon text-with-icon_wrap v-align-top"
                  type="button"
                  @click="showEditStage(i)"
                >
                  <span class="text-sm">
                    {{ $moment(item.StartDate).format('DD.MM.YYYY') }}-{{$moment(item.EndDate).format('DD.MM.YYYY')}}
                  </span>
                  <icon class="icon icon_fix" icon-name="edit" w="16" h="16"></icon>
                </button>
                <div class="text-md">Этап {{ i + 1 }}</div>
              </div>
              <div class="champ-stages__button">
                <button
                  class="button button_wide button_secondary button_dashed"
                  type="button"
                  @click="showAddStage"
                >
              <span class="button__icon">
                <icon icon-name="plus"></icon>
              </span>
                  <span class="button__text">Добавить этап</span>
                </button>
              </div>
              <div class="champ-stages__date">
                <b class="text-with-icon text-with-icon_wrap v-align-top">
                  <icon class="icon icon_fix color-muted" icon-name="calendar" w="18" h="18"></icon>
                  <span class="text-sm">{{ $moment(champ.FinishDate).format('DD MMMM YYYY') }}</span>
                </b>
              </div>
            </div>
          </div>
          <div class="form__item" v-show="ready">
            <div class="divider"></div>
          </div>
          <div class="form__item">
            <div class="grid grid_v-center grid_v-margins">
              <div class="grid__col grid__col_auto mr-auto">
                <button
                  class="action color-muted"
                  type="button"
                  @click="$emit('prev')"
                >
                <span class="action__container">
                   <span class="action__icon">
                     <icon icon-name='left'></icon>
                   </span>
                  <span class="action__text">Назад</span>
                </span>
                </button>
              </div>
              <div class="grid__col grid__col_auto" v-show="ready">
                <button
                  class="button button_primary button_lg"
                  :class="{'button_loading': isSending}"
                  :disabled="isSending"
                  type="submit"
                >
                  <span class="button__text">Продолжить</span>
                  <span class="button__icon button__loading">
                  <icon icon-name='loading'></icon>
                </span>
                  <span class="button__icon">
                  <icon icon-name='right'></icon>
                </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <modal
      align="center"
      ref="addStageModal"
    >
      <div class="modal__heading modal__item">
        <h3 class="modal__title">Добавить этап</h3>
      </div>
      <div class="modal__body modal__item">
        <date-picker
          popup-class="datepicker-calendar stages-datepicker"
          ref="calendar"
          v-model="date"
          lang="ru"
          :inline="false"
          :range="true"
          :disabled-date="disabledDate"
          range-separator="–"
          format="DD.MM.YYYY"
        >
          <template v-slot:input="d">
            <div
              class="field"
              :class="{'has-error show-errors': overlapsError}"
            >
              <div class="field__label">
                <label class="label">Период</label>
              </div>
              <div class="field__input">
                <div class="input">
                  <input
                    class="input__el"
                    placeholder="Начало – Окончание"
                    :value="d.props.value"
                    readonly
                  >
                  <div class="input__border"></div>
                  <div class="input__icons">
                    <div class="input__icon input__icon-err">
                      <icon icon-name='exclamation-circle-s'></icon>
                    </div>
                    <div class="input__icon">
                      <icon icon-name="calendar"></icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field-msg" v-show="overlapsError">
                Интервал дат пересекается с&nbsp;уже существующими, либо&nbsp;периодом чемпионата
              </div>
            </div>
          </template>
        </date-picker>
      </div>
      <div class="modal__body modal__item">
        <div class="buttons-group">
          <button
            class="button button_secondary button_lg"
            @click="cancelStage"
          >
            <span class="button__text">Отменить</span>
          </button>
          <button
            class="button button_primary button_lg"
            :class="{'disabled': emptyDate}"
            :disabled="emptyDate"
            @click="addStage"
          >
            <span class="button__text">Сохранить</span>
          </button>
        </div>
      </div>
    </modal>
    <modal
      name="edit-stage-modal"
      align="center"
      ref="editStageModal"
    >
      <div class="modal__heading modal__item">
        <h3 class="modal__title">Редактировать этап</h3>
      </div>
      <div class="modal__body modal__item">
        <date-picker
          popup-class="datepicker-calendar stages-datepicker"
          ref="calendar"
          v-model="date"
          lang="ru"
          :inline="false"
          :range="true"
          :disabled-date="disabledDate"
          range-separator="–"
          format="DD.MM.YYYY"
        >
          <template v-slot:input="d">
            <div
              class="field"
              :class="{'has-error show-errors': overlapsError}"
            >
              <div class="field__label">
                <label class="label">Период</label>
              </div>
              <div class="field__input">
                <div class="input">
                  <input
                    class="input__el"
                    placeholder="Начало – Окончание"
                    :value="d.props.value"
                    readonly
                  >
                  <div class="input__border"></div>
                  <div class="input__icons">
                    <div class="input__icon input__icon-err">
                      <icon icon-name='exclamation-circle-s'></icon>
                    </div>
                    <div class="input__icon">
                      <icon icon-name="calendar"></icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field-msg" v-show="overlapsError">
                Интервал дат пересекается с&nbsp;уже существующими, либо&nbsp;периодом чемпионата
              </div>
            </div>
          </template>
        </date-picker>
      </div>
      <div class="modal__body modal__item">
        <div class="buttons-group">
          <button
            class="button button_danger button_lg"
            @click="deleteStage"
          >
            <span class="button__text">Удалить этап</span>
          </button>
          <button
            class="button button_primary button_lg"
            :class="{'disabled': emptyDate}"
            :disabled="emptyDate"
            @click="editStage"
          >
            <span class="button__text">Сохранить</span>
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import champsService from '@/services/champsService'
import { v4 as uuidv4 } from 'uuid'
import { sortBy, isEqual, cloneDeep } from 'lodash'
import Modal from '@/components/Modal.vue'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'ChampStages',
  props: {
    champId: String,
    champ: Object
  },
  components: {
    Modal,
    DatePicker
  },
  data () {
    return {
      id: null,
      clubCode: null,
      stages: [],
      ready: false,
      date: [null, null],
      index: null,
      overlapsError: false,
      savedData: null,
      isSending: false
    }
  },
  computed: {
    emptyDate () {
      return this.date[0] === null && this.date[1] === null
    }
  },
  methods: {
    ...mapActions('alerts', ['addSomethingWrongAlert']),
    checkOverlaps (arr, index, dates) {
      let ret = false

      const range1 = this.$moment.range(
        dates[0],
        dates[1]
      )

      for (let i = 0; i < arr.length; i++) {
        if (i === index) {
          continue
        }
        const range2 = this.$moment.range(
          this.$moment(arr[i].StartDate),
          this.$moment(arr[i].EndDate)
        )
        if (range1.overlaps(range2, { adjacent: true })) {
          ret = true
          break
        }
      }

      return ret
    },
    showAddStage () {
      this.date = [null, null]
      this.overlapsError = false
      this.$refs.addStageModal.open()
    },
    addStage () {
      const date = this.date

      let overlaps = false

      if (this.stages.length > 0) {
        const arr = [null, ...this.stages]
        overlaps = this.checkOverlaps(
          arr,
          0,
          [this.$moment(date[0]), this.$moment(date[1])]
        )
      }

      this.overlapsError = overlaps

      if (overlaps) {
        return
      }

      const start = date[0]
      const finish = date[1]

      const data = {
        Id: uuidv4(),
        StartDate: this.$moment(start).format('YYYY-MM-DDTHH:mm:ss'),
        EndDate: this.$moment(finish).format('YYYY-MM-DDTHH:mm:ss'),
        Name: 'Name'
      }

      this.stages.push(data)
      this.sortStages()
      this.$refs.addStageModal.close()
      this.date = [null, null]
    },
    cancelStage () {
      this.date = [null, null]
      this.$refs.addStageModal.close()
    },
    showEditStage (i) {
      const stage = this.stages[i]
      this.index = i
      this.date = [
        new Date(stage.StartDate),
        new Date(stage.EndDate)
      ]
      this.overlapsError = false
      this.$refs.editStageModal.open()
    },
    editStage () {
      const date = this.date

      let overlaps = false

      if (this.stages.length > 0) {
        overlaps = this.checkOverlaps(
          this.stages,
          this.index,
          [this.$moment(date[0]), this.$moment(date[1])]
        )
      }

      this.overlapsError = overlaps

      if (overlaps) {
        return
      }

      const stage = this.stages[this.index]
      const start = date[0]
      const finish = date[1]

      stage.StartDate = this.$moment(start).format('YYYY-MM-DDTHH:mm:ss')
      stage.EndDate = this.$moment(finish).format('YYYY-MM-DDTHH:mm:ss')

      this.sortStages()
      this.$refs.editStageModal.close()
    },
    deleteStage () {
      this.stages.splice(this.index, 1)
      this.$refs.editStageModal.close()
    },
    sortStages () {
      this.stages = sortBy(this.stages, (o) => {
        return +this.$moment(o.StartDate).format('X')
      })
    },
    disabledDate (date) {
      const d = this.$moment(date)
      return d < this.$moment(this.champ.StartDate) ||
        d > this.$moment(this.champ.FinishDate)
    },
    submit () {
      if (this.savedData && isEqual(this.stages, this.savedData)) {
        const data = {
          total: this.stages.length,
          completed: this.getCompletedCount()
        }
        this.$emit('changed', data)
        this.$emit('next')
        return
      }

      this.isSending = true

      for (let i = 0; i < this.stages.length; i++) {
        this.stages[i].Name = 'Этап ' + (i + 1)
      }

      champsService.editChampStages({
        champId: this.champId,
        stages: this.stages
      })
        .then((res) => {
          const d = res.data
          if (d.Success) {
            this.savedData = cloneDeep(this.stages)
            const data = {
              total: this.stages.length,
              completed: this.getCompletedCount()
            }
            this.$emit('changed', data)
            this.$emit('next')
          } else {
            this.addSomethingWrongAlert()
          }
          this.isSending = false
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    },
    getStages () {
      champsService.getChampStages({ champId: this.id })
        .then((res) => {
          res.data.DatesStages.forEach((o) => {
            const start = this.$moment(o.StartDate).format('YYYY-MM-DDTHH:mm:ss')
            const finish = this.$moment(o.EndDate).format('YYYY-MM-DDTHH:mm:ss')

            const obj = o
            obj.StartDate = start
            obj.EndDate = finish

            this.stages.push(obj)
          })

          this.savedData = cloneDeep(this.stages)
          this.ready = true
        })
    },
    getCompletedCount () {
      let count = 0
      const today = this.$moment().startOf('day')

      for (let i = 0; i < this.stages.length; i++) {
        const stage = this.stages[i]
        const date = this.$moment(stage.EndDate)
        if (date.isBefore(today)) {
          count += 1
        }
      }

      return count
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.id = this.$route.params.champ

    if (this.id) {
      this.getStages()
      return
    }
    this.ready = true
  }
}
</script>

<style lang="scss">
  .champ-stages {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 2px;
      height: 100%;
      top: 0;
      left: 10px;
      background-color: map_get($color-neutral-black, 9);
    }

    &__date, &__button, &__item {
      margin-top: 24px;
    }

    &__date {
      padding-left: 2px;
      margin-top: 24px;

      &:first-child {
        margin-top: 0;
      }

      .icon {
        background-color: $color-white;
      }
    }

    &__item {
      position: relative;
      padding-left: 32px;

      &::before {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        position: absolute;
        left: 6px;
        top: 8px;
        border: 2px solid map_get($color-neutral-black, 45);
        background-color: $color-white;
        border-radius: 50%;
      }
    }
  }

  .stages-datepicker {
    @media (max-width: breakpoint(md, max)) {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);

      .mx-calendar {

        &:last-child {
          display: none;
        }
      }
    }
  }
</style>
